import React, { forwardRef } from 'react';
import styles from './index.modules.scss';
import { Text } from '@shakkerai/pro-components';
import { PopoverDropdown, Popover as MPopover } from '@mantine/core';

export const RightMenu = forwardRef((props, ref) => {
  const { children, visible, className, ...rest } = props;

  return (
    visible && (
      <div ref={ref} className={`${styles.rightMenu} ${className}`} {...rest}>
        {children}
      </div>
    )
  );
});

export const RightMenuItem = (props) => {
  const { children, ...rest } = props;

  return (
    <Text className={styles.rightMenuItem} color="white" size={12} {...rest} fw={600}>
      {children}
    </Text>
  );
};

/**
 * popover的下拉框，指定箭头配色
 * @param {*} props
 * @returns
 */
export const Dropdown = (props) => {
  const { children, className } = props;
  return <PopoverDropdown className={`${styles.dropdown} ${className}`}>{children}</PopoverDropdown>;
};

export const Popover = (props) => {
  const { children, className } = props;
  return (
    <MPopover className={className} withArrow offset={{ mainAxis: 10, crossAxis: 0 }} arrowSize={10} arrowRadius={1}>
      {children}
    </MPopover>
  );
};
